export type PublishedFilter = 'all' | 'true' | 'false';

export function isPublished(item: { published?: boolean }): boolean {
  return item.published !== false;
}

export function matchesPublishedFilter(
  published: boolean | undefined,
  filter: PublishedFilter,
): boolean {
  if (filter === 'true' && published === false) return false;
  if (filter === 'false' && published !== false) return false;
  return true;
}
